import apiFetch from '../apiFetch'

export default function (token, dossierId) {
  return apiFetch({ endPoint: `Sign/${dossierId}/GetAllDocumentSign`, method: 'GET', token: token })
}
